/*
  This is the TypeScript file for the mmp-confirm-popup component.
  It defines the logic for the confirmation dialog, including its interaction with Angular Material's dialog system.
  The component receives data via dependency injection (MAT_DIALOG_DATA) and provides a reference to the dialog instance.
*/
import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

@Component({
    selector: "app-mmp-confirm-popup",
    templateUrl: "./mmp-confirm-popup.component.html",
    styleUrls: ["./mmp-confirm-popup.component.scss"],
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class MmpConfirmPopupComponent {
  constructor(
    public confirmPopupRef: MatDialogRef<MmpConfirmPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
